// extracted by mini-css-extract-plugin
module.exports = {"searchBtn":"consm_searchBtn__2oUFX"};